import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

// Styled component with glow effect
const GlowBox = styled(Box)(({ theme, glowColor = '#00ffff', glowIntensity = 0.7 }) => ({
  position: 'relative',
  zIndex: 1,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-8px',
    left: '-8px',
    right: '-8px',
    bottom: '-8px',
    borderRadius: '16px',
    background: `linear-gradient(135deg, 
      rgba(0, 255, 255, ${glowIntensity}) 0%, 
      rgba(0, 163, 255, ${glowIntensity}) 50%, 
      rgba(0, 255, 255, ${glowIntensity}) 100%)`,
    zIndex: -1,
    filter: 'blur(15px)',
    opacity: 0.7,
    animation: 'glowPulse 3s infinite alternate'
  },
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '-4px',
    left: '-4px',
    right: '-4px',
    bottom: '-4px',
    borderRadius: '12px',
    background: `linear-gradient(45deg, 
      rgba(0, 255, 255, ${glowIntensity / 2}) 0%, 
      rgba(0, 163, 255, ${glowIntensity / 2}) 50%, 
      rgba(0, 255, 255, ${glowIntensity / 2}) 100%)`,
    zIndex: -1,
    filter: 'blur(8px)',
    opacity: 0.5,
    animation: 'glowPulse 4s infinite alternate-reverse'
  }
}));

// Component that adds a glow effect to its children
const GlowWrapper = ({ children, glowColor, glowIntensity, ...props }) => {
  return (
    <GlowBox glowColor={glowColor} glowIntensity={glowIntensity} {...props}>
      {children}
    </GlowBox>
  );
};

export default GlowWrapper;
